export const isDefinedAndDiffers = <Type>(a: Type | undefined, b: Type): boolean => {
    if (a === undefined) {
        return false;
    }

    return a !== b;
};
